import { Card, CenteredSpinner, Col, Row, Title } from '@wyz/ui';
import { useFormContext } from 'react-hook-form';
import { useManageCriteria } from '~/common/api';
import { SelectField } from '~/common/components';
import { Trans } from '~/common/context';
import { CriteriaHelpers } from '~/connect/helpers';
import { ICustomerCriteriaForm } from '~/connect/types';

const CriteriaForm = () => {
  const manageCriteria = useManageCriteria({
    getAll: { enabled: true, args: { includeInternal: false } },
  });
  const methods = useFormContext<Pick<ICustomerCriteriaForm, 'criteria'>>();

  return (
    <Card>
      <Card.Header>
        <Title heading='lg' color='tertiary' weight='bold'>
          <Trans i18nKey='app.common.criteria' />
        </Title>
      </Card.Header>
      <Card.Body>
        <Row>
          {!manageCriteria.getAll.isSuccess ? (
            <CenteredSpinner />
          ) : (
            manageCriteria.getAll.data.data
              .filter((criterion) => criterion.values.length !== 0)
              .map((criterion, index) => (
                <Col md={4} key={criterion.id} className='position-relative'>
                  <input
                    type='hidden'
                    {...methods.register(`criteria.${index}.criterion.id`)}
                    value={criterion.id}
                  />
                  <SelectField<true>
                    label={criterion.translatedName ?? criterion.name}
                    name={`criteria.${index}.value`}
                    options={CriteriaHelpers.sorterByName(criterion.values).map(
                      (criterionValue) => ({
                        label: criterionValue.label,
                        value: criterionValue.id,
                      }),
                    )}
                    required
                  />
                </Col>
              ))
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CriteriaForm;
